import React, { Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ProductCardSkeleton } from "../productCardSkeleton";

export default function MyFavoriteListSkeleton() {
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="favList-header br-y">
            <div className="row">
              {/* Left side: avatar + title + meta */}
              <div className="col-md-12 col-lg-4">
                <div className="pt-3 favListing-products">
                  <div className="favListing d-flex align-items-start">
                    {/* Circle avatar */}
                    <p className="favListing-lft favListing-red"></p>
                    <div className="favListing-rht">
                      <Skeleton
                        width={150}
                        height={20}
                        style={{ marginBottom: 8 }}
                      />
                      <ul className="list-unstyled mb-0">
                        <li>
                          <Skeleton width={80} height={14} />
                        </li>
                        <li>
                          <i className="fa-solid fa-circle" />
                        </li>
                        <li>
                          <Skeleton width={100} height={14} />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-lg-8">
                <div className="favListing-sorting mt-2 mt-md-1 mt-lg-3">
                  <div className="favListing-prodList">
                    <div className="favListing-addProducts favListing-options">
                      <Skeleton width={200} height={40} />
                    </div>
                    <div className="favListing-addSelect favListing-options">
                      <Skeleton width={220} height={40} />
                    </div>
                  </div>
                  <div className="sort-filters">
                    <div className="card-row">
                      <a
                        href="../myaccount/favorite-products-rowview.html"
                        className="row-products"
                      >
                        <span className="wes-row-filter" />
                      </a>
                      <a
                        href="../myaccount/favorite-products-cardview.html"
                        className="grid-products active"
                      >
                        <span className="wes-card-filter" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="ct-filter-product">
            <div className="row row-spacing row-equal">
              <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4" key="0">
                <ProductCardSkeleton />
              </div>
              <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4" key="1">
                <ProductCardSkeleton />
              </div>{" "}
              <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4" key="2">
                <ProductCardSkeleton />
              </div>{" "}
              <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4" key="3">
                <ProductCardSkeleton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
